<template>
  <div class="exam-mobile-progress">
    <div class="exam-mobile-progress__meta">
      <div class="exam-mobile-progress__bar-wrap" aria-hidden="true">
        <div
          class="exam-mobile-progress__bar"
          :style="{ width: `${progressPercent}%` }"
        />
      </div>
      <span class="exam-mobile-progress__count">{{ current + 1 }} / {{ total }}</span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ExamMobileProgress',
  props: {
    current: { type: Number, required: true },
    total: { type: Number, required: true },
    answers: { type: Array, default: () => [] }
  },
  emits: ['jump'],
  setup(props) {
    const answeredCount = computed(() => {
      if (!props.answers?.length) return 0
      return props.answers.filter((a) => a !== null).length
    })

    const progressPercent = computed(() => {
      if (!props.total) return 0
      return Math.round((answeredCount.value / props.total) * 100)
    })

    return { progressPercent }
  }
}
</script>
